import { useRef, useEffect, useState } from 'react';

/**
 * Custom hook to determine the current component's index among its siblings
 * @returns Object containing the ref and component index
 */
const useComponentIndex = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);
  const [componentIndex, setComponentIndex] = useState<number>(0);

  useEffect(() => {
    if (!ref.current) return;

    const parent = ref.current.parentElement;

    if (parent) {
      const children = Array.from(parent.children);
      const index = children.indexOf(ref.current);
      setComponentIndex(index);
    }
  }, []);

  return { ref, componentIndex };
};

export default useComponentIndex;
